import React, { FunctionComponent, useEffect, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
import { useMutation, useQuery } from '@tanstack/react-query';

// import { fetch_all, fetch_one } from '../lib/server_helper';
import { loginAtom } from '../../lib/auth';
import { fetchAll, fetchOne } from '../../lib/v31lib';

import { Line, CartesianGrid, XAxis, YAxis, Bar, ComposedChart, Tooltip, TooltipProps, PieChart, Pie, Cell, Legend, BarChart } from 'recharts';
import {
  ValueType,
  NameType,
} from 'recharts/types/component/DefaultTooltipContent';

import {
  Box,
  CircularProgress,
  Grid
} from '@mui/material';

import {
  Page,
  StyledButton,
  StyledSelect,
  Typography
} from '../../components/interface';

import { BookYear } from '../../models/BookYear';

// const { DateTime } = require("luxon");

type Props = {};
type RawExportStat = {
  custom_result: any
};
type Stat = {
  name: string;
  stock_value: number;
  amount: number;
};
type PieStat = {
  name: string;
  value: number;
};
type BarStat = {
  name: string;
  value: number;
  valueM1?: number;
  valueM2?: number;
};

const COLOURS = ['#105156', '#106F56', '#107956', '#108D56', '#10AB56', '#10C956', '#10E756', '#10DD7E', '#10D3A6', '#10C9CE', '#10BFF6', '#1097F6', '#108DF6'];

export const ExitExitStats: FunctionComponent<Props> = () => {
  // const theme = useTheme();
  
  const [login, setLogin] = useAtom(loginAtom);
  const [bookYear, setBookYear] = useState<number>();
  const [bookYearMinus1, setBookYearMinus1] = useState<number>();
  const [bookYearMinus2, setBookYearMinus2] = useState<number>();
  const [exportUrl, setExportUrl] = useState<string>();
  const [pieB1Stats, setPieB1Stats] = useState<PieStat[]>();
  const [pieB2Stats, setPieB2Stats] = useState<PieStat[]>();
  const [pieB3Stats, setPieB3Stats] = useState<PieStat[]>();
  const [barStats, setBarStats] = useState<BarStat[]>();
  const [barTotals, setBarTotals] = useState<{b1: number; b2: number; b3: number}>({b1: 0, b2: 0, b3: 0});
  const [onlyActive, setOnlyActive] = useState<boolean>(true);

  const {
    data: bookYears,
    // isLoading: bookYearsLoading,
    // isError: bookYearsError,
    // isSuccess: bookYearsSuccess,
    // refetch: bookYearsRefetch,
  } = useQuery({
    queryKey: ["book_years"],
    queryFn: () =>
      fetchAll<BookYear>(
        "/nl/v3/objects/fetch_all",
        {
          object: "book_year",
          fields: ["id", "short_visual"],
          order: "id DESC"
        },
        login
      ),
    enabled: !!login
  });

  







  const mutationCalculate = useMutation({
    mutationFn: () => {
      setExportUrl(undefined);
      return fetchOne<RawExportStat>(
        "/nl/v3/objects/custom_action",
        {
          object: 'exit',
          class_action: 'custom_api_exit_stats',
          handler_id: login?.id,
          book_year: bookYear,
          book_year_m1: bookYearMinus1,
          book_year_m2: bookYearMinus2
        },
        login
      );
    },
    onSuccess: (data, variables, context) => {
      let barStat:BarStat[] = [];
      let b1Amount = 0;
      let b2Amount = 0;
      let b3Amount = 0;

      if (!!data.custom_result.b1) {
        let b1Stat:PieStat[] = [];

        Object.values(data.custom_result.b1).sort((a:any, b:any) => b.count - a.count).forEach((stat:any) => {
          if (!!stat.count && (!onlyActive || (!!onlyActive && !!stat.active))) b1Stat.push({
            name: stat.name,
            value: stat.count
          });
        });

        setPieB1Stats(b1Stat);

        Object.values(data.custom_result.b1).forEach((stat:any) => {
          if (!!stat.count && (!onlyActive || (!!onlyActive && !!stat.active))) barStat.push({
            name: stat.name,
            value: stat.count
          });
          b1Amount += stat.count;
        });
      }
      if (!!data.custom_result.b2) {
        let b2Stat:PieStat[] = [];

        Object.values(data.custom_result.b2).sort((a:any, b:any) => b.count - a.count).forEach((stat:any) => {
          if (!!stat.count && (!onlyActive || (!!onlyActive && !!stat.active))) {
            b2Stat.push({
              name: stat.name,
              value: stat.count
            });
            b2Amount += stat.count;

            if (barStat.filter(fff => fff.name === stat.name).length > 0) {
              let newBarStat:BarStat[] = [];
              barStat.forEach(st => {
                if (st.name === stat.name) {
                  st.valueM1 = stat.count;
                  newBarStat.push(st);
                } else {
                  newBarStat.push(st);
                }
              });
              barStat = [...newBarStat];
            } else {
              barStat.push({
                name: stat.name,
                value: 0,
                valueM1: stat.count
              });
            }
          }
        });

        setPieB2Stats(b2Stat);
      }
      if (!!data.custom_result.b3) {
        let b3Stat:PieStat[] = [];

        Object.values(data.custom_result.b3).sort((a:any, b:any) => b.count - a.count).forEach((stat:any) => {
          if (!!stat.count && (!onlyActive || (!!onlyActive && !!stat.active))) {
            b3Stat.push({
              name: stat.name,
              value: stat.count
            });
            b3Amount += stat.count;

            if (barStat.filter(fff => fff.name === stat.name).length > 0) {
              let newBarStat:BarStat[] = [];
              barStat.forEach(st => {
                if (st.name === stat.name) {
                  st.valueM2 = stat.count;
                  newBarStat.push(st);
                } else {
                  newBarStat.push(st);
                }
              });
              barStat = [...newBarStat];
            } else {
              barStat.push({
                name: stat.name,
                value: 0,
                valueM2: stat.count
              });
            }
          }
        });

        setPieB3Stats(b3Stat);
      }
      setBarStats(barStat);
      setBarTotals({
        b1: b1Amount,
        b2: b2Amount,
        b3: b3Amount
      });
    },
  });
  const mutationExport = useMutation({
    mutationFn: () => {
      setExportUrl(undefined);
      return fetchOne<RawExportStat>(
        "/nl/v3/objects/custom_action",
        {
          object: 'exit',
          class_action: 'custom_api_exit_stats_export',
          handler_id: login?.id,
          book_year: bookYear,
          book_year_m1: bookYearMinus1,
          book_year_m2: bookYearMinus2,
          only_active: !!onlyActive ? 1 : 0
        },
        login
      );
    },
    onSuccess: (data, variables, context) => {
      setExportUrl(data.custom_result);
    },
  });








  return (<Page sx={{}} title="Exit Stats" helper="exit_stats">
    <Grid container spacing="8">
      <Grid item xs={12} md={4}>
        <StyledSelect
          label="Book Year Base (current)"
          value={bookYear?.toString() || ''}
          id='book_year'
          onChange={(v) => {setBookYear(parseInt(v, 10));}}
          list={[
            {id: '', name: "Unselected"},
            ...((bookYears || []).map(by => {return {id: by.id?.toString() || '', name: by.short_visual};}))
          ]}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <StyledSelect
          label="Book Year Previous"
          value={bookYearMinus1?.toString() || ''}
          id='book_year'
          onChange={(v) => {setBookYearMinus1(parseInt(v, 10));}}
          list={[
            {id: '', name: "Unselected"},
            ...((bookYears || []).map(by => {return {id: by.id?.toString() || '', name: by.short_visual};}))
          ]}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <StyledSelect
          label="Book Year Two Ago"
          value={bookYearMinus2?.toString() || ''}
          id='book_year'
          onChange={(v) => {setBookYearMinus2(parseInt(v, 10));}}
          list={[
            {id: '', name: "Unselected"},
            ...((bookYears || []).map(by => {return {id: by.id?.toString() || '', name: by.short_visual};}))
          ]}
        />
      </Grid>
      <Grid item xs={12}>
        {!!onlyActive && <StyledButton
          label="Also show inactive reasons"
          id='show_inactive'
          contained
          onClick={(v) => {
            setOnlyActive(false);
          }}
          sx={{
            marginRight: 1
          }}
        />}
        {!onlyActive && <StyledButton
          label="Only show active reasons"
          id='show_active'
          contained
          onClick={(v) => {
            setOnlyActive(true);
          }}
          sx={{
            marginRight: 1
          }}
        />}
        <StyledButton
          label="Spin the wheel"
          disabled={!bookYear}
          id='spin'
          contained
          onClick={(v) => {
            mutationCalculate.mutate();
          }}
        />
        <StyledButton
          label="Export the wheeled"
          disabled={!bookYear}
          id='export'
          contained
          onClick={(v) => {
            mutationExport.mutate();
          }}
          sx={{
            marginLeft: 1
          }}
        />
      </Grid>
      {!!mutationCalculate.isPending && <Grid item xs={12}>
        <CircularProgress />
      </Grid>}
      {!!exportUrl && <Grid item xs={12}>
        <Typography>Download your export here: <a href={exportUrl} target="_BLANK">{exportUrl}</a></Typography>
      </Grid>}
      {!!pieB1Stats && <Grid item xs={12}>
        <Typography variant="h3" sx={{textAlign: 'center', textDecoration: 'underline'}}>{bookYears?.filter(fff => fff.id === bookYear)[0].short_visual}</Typography>
        <PieChart width={1000} height={400}>
          <Pie data={pieB1Stats} dataKey="value" cx="50%" cy="50%" outerRadius={100} fill="#8884d8">
            {(pieB1Stats || []).map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLOURS[index % COLOURS.length]} />
            ))}
          </Pie>

          {/* <Legend
            layout="vertical"
            align="right"
            verticalAlign="top"
            payload={pieB1Stats?.reverse()?.map((el, index) => {
              return {
                value: <Box sx={{height: '34px', width: '500px', position: 'relative', display: 'inline-block', marginBottom: -1, marginTop: 1.1}}>
                  <Typography sx={{fontSize: '0.9rem'}}>{el.name} ({el.value})</Typography>
                </Box>,
                type: 'square',
                color: COLOURS[index % COLOURS.length]
              };
            })}
          /> */}
          {/* <Tooltip content={<CustomPieTooltip />} /> */}
        </PieChart>
      </Grid>}
      {!!pieB2Stats && <Grid item xs={12}>
        <Typography variant="h3" sx={{textAlign: 'center', textDecoration: 'underline'}}>{bookYears?.filter(fff => fff.id === bookYearMinus1)[0].short_visual}</Typography>
        <PieChart width={1000} height={400}>
          <Pie data={pieB2Stats} dataKey="value" cx="50%" cy="50%" outerRadius={100} fill="#8884d8">
            {(pieB2Stats || []).map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLOURS[index % COLOURS.length]} />
            ))}
          </Pie>

          {/* <Legend
            layout="vertical"
            align="right"
            verticalAlign="top"
            payload={pieB2Stats?.reverse()?.map((el, index) => {
              return {
                value: <Box sx={{height: '34px', width: '500px', position: 'relative', display: 'inline-block', marginBottom: -1, marginTop: 1.1}}>
                  <Typography sx={{fontSize: '0.9rem'}}>{el.name} ({el.value})</Typography>
                </Box>,
                type: 'square',
                color: COLOURS[index % COLOURS.length]
              };
            })}
          /> */}
          {/* <Tooltip content={<CustomPieTooltip />} /> */}
        </PieChart>
      </Grid>}
      {!!pieB3Stats && <Grid item xs={12}>
        <Typography variant="h3" sx={{textAlign: 'center', textDecoration: 'underline'}}>{bookYears?.filter(fff => fff.id === bookYearMinus2)[0].short_visual}</Typography>
        <PieChart width={1000} height={400}>
          <Pie data={pieB3Stats} dataKey="value" cx="50%" cy="50%" outerRadius={100} fill="#8884d8">
            {(pieB3Stats || []).map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLOURS[index % COLOURS.length]} />
            ))}
          </Pie>

          {/* <Legend
            layout="vertical"
            align="right"
            verticalAlign="top"
            payload={pieB3Stats?.reverse()?.map((el, index) => {
              return {
                value: <Box sx={{height: '34px', width: '500px', position: 'relative', display: 'inline-block', marginBottom: -1, marginTop: 1.1}}>
                  <Typography sx={{fontSize: '0.9rem'}}>{el.name} ({el.value})</Typography>
                </Box>,
                type: 'square',
                color: COLOURS[index % COLOURS.length]
              };
            })}
          /> */}
          {/* <Tooltip content={<CustomPieTooltip />} /> */}
        </PieChart>
      </Grid>}
      {!!barStats && <Grid item xs={12}>
        <BarChart width={1000} height={600} data={barStats}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" interval={0} angle={-25} textAnchor="end" height={150} />
          <YAxis />
          <Tooltip />
          {/* @ts-ignore */}
          {barTotals.b1 > 0 && <Bar dataKey="value" label={bookYears?.filter(fff => fff.id === bookYear)[0].short_visual} fill={COLOURS[0]} />}
          {/* @ts-ignore */}
          {barTotals.b2 > 0 && <Bar dataKey="valueM1" label={bookYears?.filter(fff => fff.id === bookYearMinus1)[0].short_visual} fill={COLOURS[4]} />}
          {/* @ts-ignore */}
          {barTotals.b3 > 0 && <Bar dataKey="valueM2" label={bookYears?.filter(fff => fff.id === bookYearMinus2)[0].short_visual} fill={COLOURS[7]} />}
          {/* <Legend
            layout="horizontal"
            align="center"
            verticalAlign="bottom"
            payload={[
              {
                value: <Box sx={{height: '34px', position: 'relative', display: 'inline-block', marginBottom: -1, marginTop: 1.1}}>
                  <Typography sx={{fontSize: '0.9rem'}}>{barTotals.b1 > 0 ? bookYears?.filter(fff => fff.id === bookYear)[0].short_visual : '-'}</Typography>
                </Box>,
                type: 'square',
                color: COLOURS[0]
              },
              {
                value: <Box sx={{height: '34px', position: 'relative', display: 'inline-block', marginBottom: -1, marginTop: 1.1}}>
                  <Typography sx={{fontSize: '0.9rem'}}>{barTotals.b2 > 0 ? bookYears?.filter(fff => fff.id === bookYearMinus1)[0].short_visual : '-'}</Typography>
                </Box>,
                type: 'square',
                color: COLOURS[4]
              },
              {
                value: <Box sx={{height: '34px', position: 'relative', display: 'inline-block', marginBottom: -1, marginTop: 1.1}}>
                  <Typography sx={{fontSize: '0.9rem'}}>{barTotals.b3 > 0 ? bookYears?.filter(fff => fff.id === bookYearMinus2)[0].short_visual : '-'}</Typography>
                </Box>,
                type: 'square',
                color: COLOURS[7]
              }
            ]}
          /> */}
        </BarChart>
      </Grid>}
    </Grid>
  </Page>);
}
